import * as msal from '@azure/msal-browser';

export const MsalPlugin = {

  install(Vue, store) {
    if (!store.state.config) {
      throw new Error('MsalPluginOptions must be specified');
    }
    const msalInstance = new msal.PublicClientApplication(store.state.config);
    MsalPlugin.msalVueObj = {
      isAuthenticated: false,

      async signIn(router) {
        try {
          const loginRequest = {
            scopes: ['User.Read'],
          };
          const loginResponse = await msalInstance.loginPopup(loginRequest);
          MsalPlugin.msalVueObj.isAuthenticated = !!loginResponse.account;
          if (loginResponse.account) {
            console.log('an account for the user was found');
            store.dispatch('User/setUser', loginResponse.account)
              .then(() => store.dispatch('User/fetchInsightlyUser', loginResponse.account.username));
            const returnTo = store.getters['ReturnTo/getReturnTo'];
            if (returnTo) {
              console.log('redirecting to original destination');
              store.dispatch('ReturnTo/setReturnTo', null).then(() => {
                router.push({ name: returnTo.name, params: returnTo.params });
              });
            } else {
              console.log('redirecting to dashboard');
              router.push({ name: 'Dashboard' });
            }
          } else {
            router.push({ name: 'SignIn' });
          }
        } catch (err) {
          // handle error
          if (err.errorMessage && err.errorMessage.indexOf('AADB2C90118') > -1) {
            try {
              const passwordResetResponse = await msalInstance.loginPopup({
                scopes: ['User.Read'],
              });
              MsalPlugin.msalVueObj.isAuthenticated = !!passwordResetResponse.account;
              if (passwordResetResponse.account) {
                store.dispatch('User/setUser', passwordResetResponse.account)
                  .then(() => store.dispatch('User/fetchInsightlyUser', passwordResetResponse.account.username));
              }
            } catch (passwordResetError) {
              console.error(passwordResetError);
            }
          } else {
            console.log('error occurred, will go to Not Authorized page');
            console.error(err);
            MsalPlugin.msalVueObj.isAuthenticated = false;
            if (router.currentRoute.name !== 'NotAuthorized') {
              router.push({ name: 'NotAuthorized' });
            }
          }
        }
      },

      async signOut(router) {
        await msalInstance.logout();
        MsalPlugin.msalVueObj.isAuthenticated = false;
        store.dispatch('User/setUser', null).then(() => {
          store.dispatch('ReturnTo/setReturnTo', null).then(() => {
            router.push({ name: 'SignIn' });
          });
        });
      },

      async acquireToken() {
        const request = {
          account: store.state.User.user,
          scopes: ['User.Read'],
        };
        try {
          const response = await msalInstance.acquireTokenSilent(request);
          return response.idToken;
        } catch (error) {
          console.log('Error occurred when acquiring Token');
          console.error(error);
          if (error instanceof msal.InteractionRequiredAuthError) {
            return msalInstance.acquireTokenPopup(request).catch((popupError) => {
              console.log('Error occurred when launching login popup');
              console.error(popupError);
            });
          }
          return false;
        }
      },

      getIsAuthenticated() {
        const accounts = msalInstance.getAllAccounts();
        return accounts && accounts.length > 0;
      },
    };
    /* eslint-disable-next-line no-param-reassign */
    Vue.prototype.$msal = Vue.observable(MsalPlugin.msalVueObj);
  },
};

export function getMsalObject() {
  return MsalPlugin.msalVueObj;
}
